import * as Sentry from '@sentry/react';
import {
  RouteObject,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';

import { FeatureFlags } from '@constants/featureFlags';
import { RoutesConfig } from '@src/types/routes';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

// Handy when generating routes controlled with feature flags
const useRoutesFeatureFlags = (): { [K in FeatureFlags]?: boolean } => {
  return {};
};

const mapRoutes = (
  config: RoutesConfig[],
  flags: Record<string, boolean | undefined>
): RouteObject[] =>
  config.reduce<RouteObject[]>(
    (routes, { path, children, flagName, ...rest }) => {
      // Route is not rendered when feature flag is falsy
      if (flagName && !flags[flagName]) {
        return routes;
      }

      if (children) {
        routes.push({ path, children: mapRoutes(children, flags), ...rest });
      } else {
        routes.push({ path, ...rest });
      }

      return routes;
    },
    []
  );

const Router = ({ routes }: { routes: RouteObject[] }) => {
  const flags = useRoutesFeatureFlags();

  return (
    <RouterProvider
      router={sentryCreateBrowserRouter(
        mapRoutes(routes as RoutesConfig[], flags),
        {
          basename: import.meta.env.BASE_URL.replace(/\/$/, ''),
        }
      )}
    />
  );
};

export { Router };
